/* eslint-disable react/no-danger */
import React from 'react'
import { Box, Container, Typography } from '@maas-components/core'
import PropTypes from 'prop-types'
import { ReactComponent as ImgBlackFriday } from 'core/assets/images/icn-black-friday.svg'
import { ReactComponent as ImgEmpty } from 'core/assets/images/icn-empty.svg'
import { ReactComponent as ImgError } from 'core/assets/images/icn-error.svg'
import { ReactComponent as ImgExclamation } from 'core/assets/images/icn-exclamation.svg'
import { ReactComponent as ImgInfo } from 'core/assets/images/icn-info.svg'
import { ReactComponent as ImgLock } from 'core/assets/images/icn-lock.svg'
import { ReactComponent as ImgSuccess } from 'core/assets/images/icn-success.svg'
import { ReactComponent as ImgWarning } from 'core/assets/images/icn-warning.svg'
import { ReactComponent as ImgMaintenance } from 'core/assets/images/maintenance.svg'
import Center from 'core/components/Center'

const statusMap = {
  success: <ImgSuccess />,
  error: <ImgError />,
  info: <ImgInfo />,
  warning: <ImgWarning />,
  404: <ImgEmpty />,
  500: <ImgExclamation />,
  403: <ImgLock />,
  blackfriday: <ImgBlackFriday />,
  maintenance: <ImgMaintenance />,
}

const Result = props => {
  const { title, subtitle, image, status, children } = props

  return (
    <Container maxWidth="md">
      <Center>
        <Typography align="center" variant="h2" className="mb-2">
          {title}
        </Typography>
        <Typography align="center" variant="body1" color="textSecondary" gutterBottom>
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </Typography>
        <Box className="mt-7" py={2}>
          {image ?? statusMap[status]}
        </Box>
        <Box py={2}>{children}</Box>
      </Center>
    </Container>
  )
}

Result.propTypes = {
  children: PropTypes.node,
  image: PropTypes.node,
  status: PropTypes.oneOf([
    'blackfriday',
    'success',
    'error',
    'info',
    'warning',
    '404',
    '403',
    '500',
  ]),
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

Result.defaultProps = {
  children: null,
  image: null,
  status: 'info',
}

export default Result
